import gql from "graphql-tag";

export const deleteTopFeatureMutation = gql`
mutation deleteTopFeature($id: Int) {
    deleteTopFeature(id: $id) {
    status
    errorMessage
  }
}`;

export const getAllHomePageCategorySettings = gql
  `query getAllHomePageCategorySettings {
  getAllHomePageCategorySettings {
      status
      errorMessage
      results{
      id
      title
      description
      logo
      banner
      }
  }
}`;

export const updateHomePageCategoryStatusMutation = gql`
mutation updateTopFeatureStatus($id: Int, $isActive: Int) {
  updateTopFeatureStatus(id: $id, isActive: $isActive) {
    status
    errorMessage
  }
}`;